import { GroupProfileRole, PackResource, ProfileGroupStatus } from '@foxbun/lib-goferal-types';
import { AbstractModelOptions } from '../stores/models/abstract/AbstractModelStore';
import { generatePath } from 'react-router-dom';
import { observable } from 'mobx';
import { ProfileModel } from './ProfileModel';
import { ProfileStore } from '../stores/models/ProfileStore';
import { Routing } from '../../pages/Routing';
import { ResourceModel } from './ResourceModel';

export interface PackMember {
  member: ProfileModel;
  role: GroupProfileRole;
}

export interface PackModelOptions extends AbstractModelOptions<PackResource> {
  user_store: ProfileStore;
}

export class PackModel extends ResourceModel<PackResource> {
  @observable
  accessor my_status_loading: boolean;

  @observable
  accessor my_status: ProfileGroupStatus | null;

  @observable
  accessor members: PackMember[];

  constructor(protected options2: PackModelOptions) {
    super(options2);
    this.my_status_loading = false;
    this.my_status = null;
    this.members = [];
  }

  get link() {
    return generatePath(Routing.PACK, {
      id: this.data._id.toString()
    });
  }

  async refresh() {
    this.setData(await this.options.api_client.packs.getPack({ _id: this.id }));
  }

  async loadMyRelation() {
    this.my_status_loading = true;
    try {
      this.my_status = await this.options.api_client.packs.getMyPackStatus({
        _id: this.id
      });
    } finally {
      this.my_status_loading = false;
    }
  }

  async revokeRequestToJoin() {
    await this.options.api_client.packs.revokeRequestToJoin({
      _id: this.id
    });
    await this.loadMyRelation();
  }

  async requestToJoin() {
    await this.options.api_client.packs.requestToJoinPack({
      _id: this.id
    });
    await this.loadMyRelation();
  }

  async inviteMember(member: ProfileModel, role: GroupProfileRole) {
    await this.options.api_client.packs.invitePackMember({
      pack_id: this.id,
      role: role,
      user_id: member.id
    });
  }

  async loadMembers() {
    let res = this.options.api_client.packs
      .getPackMembers({
        group_id: this.id
      })
      .generator();

    this.members = [];

    for await (let page of res) {
      this.members = this.members.concat(
        page.map((i) => {
          return {
            member: this.options2.user_store.getModel(i.user_id),
            role: i.role
          };
        })
      );
    }
  }

  async leave() {
    let res = this.options.api_client.packs.leavePack({
      _id: this.id
    });
  }
}
